import { isEmpty } from 'lodash';
import { activeStatus } from './filterActiveTicketByChildrenStatus';
import { KdsTicket, TicketStatus } from '../types/ticket';
import { KdsLinesMap } from '../types/kds-line';

const areAllChildrenUnactive = (
    linesMap: KdsLinesMap,
    isLocalAssemble: boolean,
    isProductFollowUpEnabled: boolean,
): boolean =>
    Object.values(linesMap).reduce<boolean>((allChildrenAreUnactive, { status, kdsLines }) => {
        if (!allChildrenAreUnactive) {
            return false;
        }

        if (!isEmpty(kdsLines)) {
            return areAllChildrenUnactive(kdsLines, isLocalAssemble, isProductFollowUpEnabled);
        }

        return !activeStatus(isLocalAssemble, isProductFollowUpEnabled).includes(status) && allChildrenAreUnactive;
    }, true);

const filterWithDisplayerStatus = (status: TicketStatus, displayClientDisplay: boolean): boolean => {
    if (!displayClientDisplay) {
        return true;
    }

    return status !== TicketStatus.ToDisplay && status !== TicketStatus.Displaying;
};

const isPartOfDoneGroup = (
    groupingKey: string,
    tickets: KdsTicket[],
    isLocalAssemble: boolean,
    displayClientDisplay: boolean,
    isProductFollowUpEnabled: boolean,
): boolean => {
    const groupedTickets = tickets.filter((ticket) => ticket.comment == null && ticket.groupingKey === groupingKey);

    return groupedTickets.every(
        ({ status, kdsLines }) =>
            isUnactiveTicket(status) ||
            isTicketOnDisplayer(status, kdsLines, isLocalAssemble, displayClientDisplay, isProductFollowUpEnabled),
    );
};

const isTicketOnDisplayer = (
    status: TicketStatus,
    kdsLines: KdsLinesMap,
    isLocalAssemble: boolean,
    displayClientDisplay: boolean,
    isProductFollowUpEnabled: boolean,
): boolean => {
    return (
        status !== TicketStatus.Modified &&
        status !== TicketStatus.ToCancel &&
        filterWithDisplayerStatus(status, displayClientDisplay) &&
        areAllChildrenUnactive(kdsLines, isLocalAssemble, isProductFollowUpEnabled)
    );
};

const isUnactiveTicket = (status: TicketStatus): boolean => {
    return status === TicketStatus.Done || status === TicketStatus.Cancelled;
};

export const filterUnactiveTicketByChildrenStatus = (
    tickets: KdsTicket[],
    isLocalAssemble: boolean,
    displayClientDisplay: boolean,
    isProductFollowUpEnabled = false,
): KdsTicket[] => {
    return tickets.filter(({ kdsLines, status, groupingKey, comment }) =>
        groupingKey != null && comment == null
            ? status === TicketStatus.Cancelled ||
              isPartOfDoneGroup(groupingKey, tickets, isLocalAssemble, displayClientDisplay, isProductFollowUpEnabled)
            : isUnactiveTicket(status) ||
              isTicketOnDisplayer(status, kdsLines, isLocalAssemble, displayClientDisplay, isProductFollowUpEnabled),
    );
};
